export default __webpack_public_path__ + "static/Economic Model Update - Greek-2962909395c3f485288ce16a299863ea.pdf";